import _jsx from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'react';
import 'prop-types';
import classnames from 'classnames';
import { ExpandableSection } from '@andes/expandable-section';
import { jsx } from 'react/jsx-runtime';
const namespace = "seo-ui-info-text-box";
const removeHtmlTags = input => {
  return input.replace(/<[^>]*>/g, "");
};
const InfoTextBox = _ref => {
  let {
    title,
    description,
    device,
    expandableProps,
    charCountToExpand = 500,
    forceExpand = false
  } = _ref;
  const deviceClass = device === "desktop" ? "desktop" : "mobile";
  const {
    expansionText,
    contractionText,
    size,
    defaultHeight = 130,
    color
  } = expandableProps || {};
  const charCount = removeHtmlTags(description).length;
  const renderDescription = () => {
    const optionalSimpleProps = _objectSpread(_objectSpread(_objectSpread({}, expansionText !== undefined ? {
      expansionText
    } : {}), contractionText !== undefined ? {
      contractionText
    } : {}), color !== undefined ? {
      color
    } : {});
    const componentProps = _objectSpread({
      id: "".concat(namespace, "__expandable-section"),
      defaultHeight,
      simple: optionalSimpleProps
    }, size !== undefined ? {
      size
    } : {});
    return /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__description-container")
    }, void 0, charCount >= charCountToExpand && !forceExpand ? /*#__PURE__*/jsx(ExpandableSection, _objectSpread(_objectSpread({}, componentProps), {}, {
      children: /*#__PURE__*/_jsx("div", {
        className: "".concat(namespace, "__expandable-htlm-content ").concat(deviceClass)
        // eslint-disable-next-line react/no-danger
        ,

        dangerouslySetInnerHTML: {
          __html: description
        }
      })
    })) : /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__htlm-content ").concat(deviceClass)
      // eslint-disable-next-line react/no-danger
      ,

      dangerouslySetInnerHTML: {
        __html: description
      }
    }));
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames(namespace, "".concat(namespace, "--").concat(device))
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: classnames("".concat(namespace, "__container"))
  }, void 0, /*#__PURE__*/_jsx("h2", {
    className: "".concat(namespace, "__title ").concat(deviceClass)
  }, void 0, title), description && renderDescription()));
};
InfoTextBox.displayName = "InfoTextBox";
export { InfoTextBox as default };
